import { useContext } from "react";
import ShowMoreContext from "./show-more-context";

const useShowMoreContext = () => {
  const context = useContext(ShowMoreContext);
  if (context === undefined) {
    throw new Error(
      "ShowMore compound components cannot be rendered outside the ShowMore component",
    );
  }

  return context;
};

export default useShowMoreContext;
